
import Vue, { readonly } from 'vue';
import { ViewsPaymentTransfer_GetPaymentTransferBulkPayment, ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables, Risolto_Payment_Transfer_Status_Enum } from '@/generated/graphql';
import Logging from '@/logging';
import axios from 'axios';
import { excerpt } from '@/filters';

export default Vue.extend({
	data() {
		return {
			show_unmatched_lines: true,
			hide_simple_matches: false,
			activeTabName: 'statementsTab',
			selectedLegalEntityReference: [],
			selectedPaymentTransferReference: [],
			statementLines: [],
			paymentTransferLines: [],
			bulkPayment: undefined,
			loading: true,
			readonly: true
		};
	},
	created() {
		this.show_unmatched_lines = true;
		this.selectedLegalEntityReference = this.$route.params.legalEntity;
		this.selectedPaymentTransferReference = this.$route.params.paymentTransfer;
		this.onSelectedPaymentTransferChanged();
	},
	methods: {
		async onSelectedPaymentTransferChanged() {
			this.bulkPayment = undefined;
			await this.reload();
		},
		async reload() {
			await Promise.all([
				this.getStatementLinesAsync(),
				this.getPaymentTransferLinesAsync()
			]);

			if (this.readonly) {
				this.getBulkPayment();
			}
		},
		getStatementLinesAsync(): Promise<void> {
			return new Promise((resolve) => {
				this.getStatementLines();
				resolve();
			});
		},

		getPaymentTransferLinesAsync(): Promise<void> {
			return new Promise((resolve) => {
				this.getPaymentTransferLines();
				resolve();
			});
		},
		async getStatementLines() {
			this.loading = true;

			try {
				let participant = this.$store.state.risolto.selectedParticipantStore;
				let legal_entity = this.selectedLegalEntityReference;
				let payment_transfer = this.selectedPaymentTransferReference;
				if (!this.selectedPaymentTransferReference) { return; }
				const url = `https://${process.env.VUE_APP_API_ENDPOINT}/payment-transfer/v1/payment-transfer/${payment_transfer}/statement-lines
								?participant=${participant}
								&legal_entity=${legal_entity}
								&payment_transfer=${payment_transfer}
								&return_unmatched_lines=${this.show_unmatched_lines}
								&skip_simple_matches=${this.hide_simple_matches}`;
				const response = await axios.get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } });
				this.statementLines = response.data.data;
			} catch (e) {
				this.loading = false;
				Logging.error(e);
			}

			this.loading = false;
		},
		async getPaymentTransferLines() {
			this.loading = true;

			try {
				let participant = this.$store.state.risolto.selectedParticipantStore;
				let legal_entity = this.selectedLegalEntityReference;
				let payment_transfer = this.selectedPaymentTransferReference;
				const url = `https://${process.env.VUE_APP_API_ENDPOINT}/payment-transfer/v1/payment-transfer/${payment_transfer}/simulated-payment-transfer-lines?participant=${participant}&legal_entity=${legal_entity}&payment_transfer=${payment_transfer}&return_unmatched_lines=${this.show_unmatched_lines}`;
				const response = await axios.get(url, { headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` } });
				this.paymentTransferLines = response.data.data;
			} catch (e) {
				this.loading = false;
				Logging.error(e);
			}

			this.loading = false;
		},
		async getBulkPayment() {
			if (this.selectedPaymentTransferReferenc.length === 0 || this.readOnly) {
				return;
			}

			let variables: ViewsPaymentTransfer_GetPaymentTransferBulkPaymentQueryVariables = {
				participant: this.selectedParticipantStore,
				payment_transfer: this.selectedPaymentTransferReference
			};

			let result = await this.$apollo.query({
				query: ViewsPaymentTransfer_GetPaymentTransferBulkPayment,
				variables: variables
			});

			this.bulkPayment = result.data.records[0];
		},
		translateMatchTypeDescription(match_type: string) {
			enum MatchTypeEnum {
				INVOICE = 'INVOICE',
				PAYMENT_PROMISE = 'PAYMENT_PROMISE',
				DUNNING_NOTICE = 'DUNNING_NOTICE'
			}

			if (match_type === MatchTypeEnum.INVOICE) {
				return this.$t('PaymentTransferDetails.MatchType.Invoice');
			} else if (match_type === MatchTypeEnum.PAYMENT_PROMISE) {
				return this.$t('PaymentTransferDetails.MatchType.PaymentPromise');
			} else if (match_type === MatchTypeEnum.DUNNING_NOTICE) {
				return this.$t('PaymentTransferDetails.MatchType.DunningNotice');
			}
		},
		translateMatchStatusDescription(row: any) {
			enum MatchStatusEnum {
				MATCHED = 'MATCHED',
				UNMATCHED = 'UNMATCHED',
				MATCHEDMULTIPLE = 'MATCHEDMULTIPLE'
			}

			if (row.selected_match_status === MatchStatusEnum.MATCHED) {
				return this.$t('PaymentTransferDetails.MatchStatus.Matched');
			} else if (row.selected_match_status === MatchStatusEnum.UNMATCHED) {
				return this.$t('PaymentTransferDetails.MatchStatus.Unmatched');
			} else if (row.selected_match_status === MatchStatusEnum.MATCHEDMULTIPLE) {
				return this.$t('PaymentTransferDetails.MatchStatus.MatchedMultiple');
			}
		},
		translatePaymentTransferLineType(type: string) {
			enum PaymentTransferLineType {
				PRINCIPLE_AMOUNT = 'PRINCIPLE_AMOUNT',
				COSTS_AND_INTERESTS = 'COSTS_AND_INTERESTS',
				OTHER = 'OTHER'
			}

			if (type === PaymentTransferLineType.PRINCIPLE_AMOUNT) {
				return this.$t('PaymentTransferDetails.PaymentTransferLineType.PrincipleAmount');
			} else if (type === PaymentTransferLineType.COSTS_AND_INTERESTS) {
				return this.$t('PaymentTransferDetails.PaymentTransferLineType.CostsAndInterests');
			} else if (type === PaymentTransferLineType.OTHER) {
				return this.$t('PaymentTransferDetails.PaymentTransferLineType.Other');
			}
		},
		formatDate(row, column) {
			return new Date(row[column.property].value).toLocaleDateString();
		},
		async onChangeShowUnmatchedLines() {
			await this.reload();
		},
		async onChangeHideSimpleMatches() {
			await this.reload();
		}
	}
});
